
/* injects from baggage-loader */

'use strict';

import _ from 'lodash';
import sellerCashierSearchTpl from '!!file-loader?name=templates/[name].[ext]!./sellerCashierSearch.html';

/**
 * Directive used for manipulate the HTML DOM elements inside the sellerCashierSearch component
 */
function sellerCashierSearchComponent() {

	/**
	 * Directive definition
	 */
	const directive = {
		restrict: 'E',
		templateUrl: sellerCashierSearchTpl,
		controller: SellerCashierSearchController,
		controllerAs: 'sellercashiersearchvm',
		bindToController: true,
		scope: {
			reciver: '=',
			clearComponents: '&'
		}
	};

	return directive;

	function SellerCashierSearchController(utilitiesConstant, utilitiesFactory, restClientServices, sessionFactory, sellerCashierSearchConstant) {
		'ngInject';

		/**
		 * Scope for manipulated data in HTML DOM elements.
		 */
		const user = angular.fromJson(sessionFactory.get(utilitiesConstant.STORAGE.USER));
		let vm = this;
		let offices;
		vm.searchSellerText = '';
		vm.searchCashierText = '';
		vm.sellers = [];
		vm.cashiers = [];
		vm.constant = sellerCashierSearchConstant;

		/**
		 * Filters sellers by name and username
		 */
		vm.searchSeller = searchText => vm.sellers.filter(seller => _.includes(seller.name.toLowerCase(), searchText.toLowerCase()) || _.includes(seller.identification, searchText));
		/**
 		* Filters chasier by name and username
 		*/
		vm.searchCashier = searchText => vm.cashiers.filter(cashier => _.includes(cashier.name.toLowerCase(), searchText.toLowerCase()) || _.includes(cashier.identification, searchText));

		(function () {
			/**
			 * Gets sellers from the server
			 */
			const sellersCashiersUrl = utilitiesConstant.URL_ENDPOINT_GANA.concat(utilitiesConstant.URL_API_METHOD.SELLERS_CASHIERS);

			restClientServices.ganaService(sellersCashiersUrl, { userId: user.office.code })
				.then(response => {
					vm.sellers = response.sellers;
					vm.cashiers = response.cashiers;
				},
				error => {
					if (error.status === 404) {
						utilitiesFactory.showAlertMessage(sellerCashierSearchConstant.NOT_FOUND_SELLERS);
					} else {
						utilitiesFactory.showErrorMessage(utilitiesConstant.MSG_ERROR);
					}
				});
		})();
	}
}

export default sellerCashierSearchComponent;



// WEBPACK FOOTER //
// ./src/app/core/components/sellerCashierSearch/sellerCashierSearch.directive.js